import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { JobsService } from '../../../services';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IProfileJobInfo } from '../../../interfaces/telephony/profile-job-info';

@Component({
  selector: 'supplier-profile-all-jobs',
  templateUrl: './supplier-profile-all-jobs.component.html',
  styleUrls: ['./supplier-profile-all-jobs.component.scss'],
})
export class SupplierProfileAllJobsComponent implements OnInit, OnDestroy {
  @Input() supplierHomePos: any;

  constructor(private jobService: JobsService) {}

  jobs: IProfileJobInfo[];
  isBusy = false;

  private searchSubject: Subject<string> = new Subject();
  searchText: string;

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchText) => {
      this.searchJobs(searchText);
    });
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
  }

  searchJobs(text: string) {
    // load all organisation information once on start
    this.isBusy = true;
    this.jobService
      .searchJobsByRegFull(text)
      .then((res) => {
        this.jobs = res;
        this.isBusy = false;
      })
      .catch(() => {
        this.isBusy = false;
      });
  }

  searchTextChanged(text: string): void {
    text = text || '';
    this.searchText = text;

    if (this.searchText.length >= 3) {
      this.searchSubject.next(this.searchText);
    }
  }

  resetVrm() {
    this.searchText = '';
    this.jobs = [];
  }
}
